import { createFileRoute } from '@tanstack/react-router';

import { AttendanceClassListPage } from '~features/classes/ui/attendance-class-list-page';

export const Route = createFileRoute('/_auth/_layout/attendance/')({
  component: AttendanceClassListPage,
});
